// ============================================================
// Datei: src/components/GuestRegistrationMobile.jsx
//
// Zweck:
// - Mobile-Ansicht für die Gastregistrierung
// - verwendet bewusst dieselbe Logik wie Desktop
//
// ÄNDERUNGEN:
// - keine eigene Duplikat-Logik nötig
// - alle neuen Berechtigungsregeln kommen aus GuestRegistrationDesktop
// ============================================================

import GuestRegistrationDesktop from "./GuestRegistrationDesktop";
import "./guestRegistrationMobile.css";

/*
	Warum diese Datei so kurz ist:
	- Die Formularlogik bleibt an einem Ort.
	- Dadurch müssen Berechtigungen nur einmal angepasst werden.
	- Das Mobile-CSS sorgt für die passende Darstellung.
*/
export default GuestRegistrationDesktop;